var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacehelganegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "face_helga_negative_svg__c",
    width: 48.374,
    height: 64.837,
    x: 0.453,
    y: 0.439,
    rx: 24.187
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_helga_negative_svg__e",
    width: 244.034,
    height: 286.871,
    x: 0,
    y: 0,
    rx: 122.017
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_helga_negative_svg__g",
    width: 100.77,
    height: 79.011,
    x: 0.509,
    y: 0.51,
    rx: 21.87
  }), /*#__PURE__*/React.createElement("rect", {
    id: "face_helga_negative_svg__i",
    width: 100.77,
    height: 79.011,
    x: 0.03,
    y: 0.51,
    rx: 21.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_helga_negative_svg__a",
    d: "M.964 148.045C.964 66.282 67.25 0 149.02 0h64.855c81.768 0 148.055 66.284 148.055 148.045v46.765c0 81.763-60.356 120.634-134.808 86.847 0 0-37.144-16.92-37.438-16.92-5.785 0-52.309 20.588-52.309 20.588C62.037 317.098.964 276.57.964 194.81v-46.765z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.446 42.84)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_helga_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_helga_negative_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 12.15,
    d: "M213.874-6.075c42.561 0 81.093 17.25 108.985 45.14 27.893 27.891 45.145 66.421 45.145 108.98h0v46.765c0 43.484-16.437 75.22-42.267 91.86-25.831 16.641-61.528 18.489-101.134.515-.7-.318-8.573-3.905-16.926-7.696h0l-1.116-.507-.355-.161-.71-.325-.708-.327-.707-.328h0l-.703-.329a457.931 457.931 0 01-10.31-5.021l-.441-.221-.211-.106-.402-.202-.72-.361-.73-.365c-.544-.273-.857-.425-.881-.425-2.432 0-12.669 4.328-23.029 8.6h0l-1.483.614h0l-1.226.51-.408.17-.814.34c-11.922 4.981-22.89 9.835-22.89 9.835-40.096 16.911-76.166 14.149-102.274-3.175C11.451 270.381-5.11 238.22-5.11 194.81h0v-46.765c0-42.56 17.252-81.09 45.144-108.98s66.424-45.14 108.986-45.14h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#363A4F",
    strokeLinecap: "round",
    strokeWidth: 12.15,
    d: "M213.874-6.075c42.561 0 81.093 17.25 108.985 45.14 27.893 27.891 45.145 66.421 45.145 108.98h0v46.765c0 43.484-16.437 75.22-42.267 91.86-25.831 16.641-61.528 18.489-101.134.515-.7-.318-8.573-3.905-16.926-7.696h0l-1.116-.507-.355-.161-.71-.325-.708-.327-.707-.328h0l-.703-.329a457.931 457.931 0 01-10.31-5.021l-.441-.221-.211-.106-.402-.202-.72-.361-.73-.365c-.544-.273-.857-.425-.881-.425-2.432 0-12.669 4.328-23.029 8.6h0l-1.483.614h0l-1.226.51-.408.17-.814.34c-11.922 4.981-22.89 9.835-22.89 9.835-40.096 16.911-76.166 14.149-102.274-3.175C11.451 270.381-5.11 238.22-5.11 194.81h0v-46.765c0-42.56 17.252-81.09 45.144-108.98s66.424-45.14 108.986-45.14h0z",
    mask: "url(#face_helga_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M318.065 38.192S211.289-6.282 135.917 11.809C60.544 29.901 13.81 87.517 13.81 123.237s-23.312 142.082 90.538 186.3L-6.157 287.428l-9.715-92.081L-13.86 80.24 5.486 4.604l180.728-31.487 159.785 14.74-27.934 50.335zM301.175 251.299l-11.572 32.786s51.108.964 62.679-31.822l-32.786 36.643-54 8.679 35.679-46.286z",
    mask: "url(#face_helga_negative_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M304.431 135.694l15.742 40.41 11.349 46.146s10.302-82.07-14.74-98.99c-8.445 8.162-12.35 12.434-12.35 12.434z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.045 88.843)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.53,
    cy: 168.113,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.15,
    rx: 31.562,
    ry: 31.607
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.321,
    cy: 166.109,
    r: 13.5,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.637,
    cy: 168.113,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.15,
    rx: 31.562,
    ry: 31.607
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.66,
    cy: 208.461,
    fill: "#00AFAA",
    stroke: "#363A50",
    strokeWidth: 6.696,
    rx: 9.375,
    ry: 18.08,
    transform: "matrix(1 0 0 -1 0 416.922)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.107,
    cy: 208.461,
    fill: "#00AFAA",
    stroke: "#363A50",
    strokeWidth: 6.696,
    rx: 9.375,
    ry: 18.08,
    transform: "matrix(1 0 0 -1 0 416.922)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.75,
    cy: 169.002,
    r: 13.5,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.626 263)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_helga_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_helga_negative_svg__c"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 60.524,
    height: 76.987,
    x: -5.622,
    y: -5.636,
    stroke: "#363A50",
    strokeWidth: 12.15,
    rx: 30.262
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75.274,
    height: 100.891,
    x: -13.431,
    y: -25.601,
    fill: "#F9CCB6",
    mask: "url(#face_helga_negative_svg__d)",
    rx: 37.637
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M7.918 12.013S-2.495 44.996 24.404 62.356c26.899 17.36-5.206 16.492-5.206 16.492l-35.576-29.512-.868-32.115 25.164-5.208z",
    mask: "url(#face_helga_negative_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.78 .366)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_helga_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_helga_negative_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#face_helga_negative_svg__e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 231.884,
    height: 282.493,
    x: 6.075,
    y: 6.075,
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.15,
    mask: "url(#face_helga_negative_svg__f)",
    rx: 115.942
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "112.821 242.036 132.107 242.036 122.464 251.607",
    mask: "url(#face_helga_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M124.38 97.216s70.345-12.687 82.7-24.077c0 0 27.346 17.376 27.346 36.804l-5.654-35.505-18.05-24.04-86.341 46.818z",
    mask: "url(#face_helga_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.984,
    height: 85.089,
    x: 131.123,
    y: 109.4,
    fill: "#F7C4AE",
    mask: "url(#face_helga_negative_svg__f)",
    rx: 42.544
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.984,
    height: 85.089,
    x: 9.713,
    y: 109.4,
    fill: "#F7C4AE",
    mask: "url(#face_helga_negative_svg__f)",
    rx: 42.544
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.095,
    cy: 29.781,
    fill: "#F8C4AC",
    mask: "url(#face_helga_negative_svg__f)",
    rx: 140.228,
    ry: 44.368
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.505,
    d: "M233.43 105.145c-9.257-7.767-25.496-3.654-36.271 9.187"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.768,
    cy: 200.089,
    r: 13.018,
    fill: "#000",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.505,
    d: "M83.822 102.066c10.465-6.042 25.744.828 34.125 15.346"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.103,
    d: "M141.436 200.505c0 7.19 5.827 13.02 13.015 13.02h0c7.188 0 13.016-5.83 13.016-13.02"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.607 123.179)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.071)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_helga_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_helga_negative_svg__g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#face_helga_negative_svg__g"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88.62,
    height: 66.861,
    x: 6.584,
    y: 6.585,
    fill: "#FFF",
    stroke: "#363A4F",
    strokeWidth: 12.15,
    mask: "url(#face_helga_negative_svg__h)",
    rx: 21.87
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "4.235 28.474 77.727 84.252 .509 82.952",
    mask: "url(#face_helga_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 98.979,
    x2: 139.062,
    y1: 39.407,
    y2: 39.407,
    stroke: "#363A4E",
    strokeLinecap: "square",
    strokeWidth: 12.15
  }), /*#__PURE__*/React.createElement("mask", {
    id: "face_helga_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_helga_negative_svg__i"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#face_helga_negative_svg__i"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88.62,
    height: 66.861,
    x: 6.105,
    y: 6.585,
    fill: "#FFF",
    stroke: "#363A4F",
    strokeWidth: 12.15,
    mask: "url(#face_helga_negative_svg__j)",
    rx: 21.87
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "3.755 13.045 77.248 68.823 .03 67.524",
    mask: "url(#face_helga_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.696,
    d: "M172.377 37.851c0-5.273 4.079-9.548 9.11-9.548h0c5.033 0 9.112 4.275 9.112 9.548M43.957 37.851c0-5.273 4.079-9.548 9.11-9.548h0c5.033 0 9.112 4.275 9.112 9.548"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.253,
    d: "M24.892 160.956c5.18-3.112 11.897-1.441 15.006 3.732h0c3.108 5.172 1.429 11.888-3.75 15M269.16 162.847c4.56-3.964 11.466-3.485 15.425 1.07h0c3.959 4.554 3.472 11.46-1.088 15.423"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.954,
    d: "M130.155 234.357c0-4.794 11.85-8.68 26.465-8.68h0c14.617 0 26.465 3.886 26.465 8.68M118.798 231.623c-.74 0-1.339 1.799-1.339 4.018h0c0 2.219.6 4.018 1.34 4.018M196.477 231.623c.74 0 1.34 1.799 1.34 4.018h0c0 2.219-.6 4.018-1.34 4.018"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFB7A3",
    strokeLinecap: "round",
    strokeWidth: 6.696,
    d: "M224.735 207.633c.74 0-.133 23.789-.133 26.008 0 2.219-.6 4.018-1.34 4.018l1.473-30.026zM93.65 208.972c-.74 0 .132 23.79.132 26.008 0 2.22.6 4.018 1.34 4.018l-1.473-30.026z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    d: "M319.694 120.982s-108.677 89.196-231.873 89.196c0 0-43.823-100.86 57.5-134.266 101.325-33.405 174.373 45.07 174.373 45.07z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.414,
    d: "M82.174 208.059s167.945-8.71 231.243-84.32"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacehelganegative);
export default __webpack_public_path__ + "static/media/face.helga.negative.e06f7ea4.svg";
export { ForwardRef as ReactComponent };